import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AppLoader } from '@/components/common/AppLoader'
import { useAuthStore } from '@/stores/useAuthStore'
import { apexUrl, getTenantSlugFromHost } from '@/lib/tenantHost'

/** Full-page navigation to another host (react-router can't leave the origin). */
export function ExternalRedirect({ to }: { to: string }): React.ReactElement {
  useEffect(() => {
    window.location.replace(to)
  }, [to])
  return <AppLoader />
}

/** Marketing and signup pages live on the main site; a tenant subdomain sends them there. */
export function MainSiteOnly({ children }: { children: React.ReactNode }): React.ReactElement {
  const { pathname, search } = useLocation()
  if (getTenantSlugFromHost()) {
    return <ExternalRedirect to={apexUrl(`${pathname}${search}`)} />
  }
  return <>{children}</>
}

/** "/" is the landing page on the main site and the app's front door on a tenant subdomain. */
export function HomeRoute({ landing }: { landing: React.ReactNode }): React.ReactElement {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  if (getTenantSlugFromHost()) {
    return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />
  }
  return <>{landing}</>
}
